import * as flexsearch from "flexsearch";

import { search as searchApi } from "apis-v2/callables";
import { IWorkspaceResourceAsset, IWorkspaceResourceWithDocument, WorkspaceResourceType } from "common/interfaces";
import { ISharedAssetsSearchDocument } from "common/interfaces/search/ISearchDocument";

import { BaseWorkspaceResourcesController, BaseWorkspaceResourcesControllerState } from "./BaseWorkspaceResourcesController";

export type ISharedAssetsPaneAsset = null;

export type SharedAssetsPaneControllerState = BaseWorkspaceResourcesControllerState<ISharedAssetsPaneAsset, IWorkspaceResourceAsset>;

class SharedAssetsPaneController extends BaseWorkspaceResourcesController<ISharedAssetsPaneAsset, IWorkspaceResourceAsset, ISharedAssetsSearchDocument> {
    protected get _documentFields() {
        return [];
    }

    protected get _batchSize() {
        return 20;
    }

    protected _searchDocumentToResourceWithDocument(searchDocument: ISharedAssetsSearchDocument): IWorkspaceResourceWithDocument<ISharedAssetsPaneAsset, IWorkspaceResourceAsset> {
        return {
            resource: searchDocument.resource,
            permission: searchDocument.permission,
            document: null,
            composedAt: searchDocument.composedAt,
        };
    }

    protected async _fetchSearchIndex({ locale, workspaceId }: { locale: string, workspaceId: string }): Promise<{ indexConfig: flexsearch.DocumentOptions<any>, indexFileReadUrl: string }> {
        return searchApi.getSharedAssetsSearchIndex({ workspaceId, locale });
    }

    public initialize(props: Omit<Parameters<BaseWorkspaceResourcesController<ISharedAssetsPaneAsset, IWorkspaceResourceAsset, ISharedAssetsSearchDocument>["initialize"]>[0], "resourceTypes">) {
        return super.initialize({ ...props, resourceTypes: [WorkspaceResourceType.ASSET] });
    }
}

const sharedAssetsPaneController = new SharedAssetsPaneController();
export default sharedAssetsPaneController;
